import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    padding: '0 11px'
  },
  text: {
    fontSize: '16px',
    lineHeight: '150%',
    letterSpacing: '0.15px',
  },
  input: {
    margin: '32px 0 0 0',
  },
  button: {
    margin: '80px 0 0 0',
  }
}))
